import React, { useMemo } from 'react'
import { node, oneOf } from 'prop-types'
import { HoneycombThemeProvider } from '@binance-chain/honeycomb'

import isElectron from '../../utils/isElectron'
import lightTheme from '../../themes/light'
import darkTheme from '../../themes/dark'

export const DexThemeProvider = ({ children, theme }) => {
  const { variant, localTheme } = useMemo(
    () => ({
      variant: theme === 'light' ? 'light' : 'dark',
      localTheme: theme === 'light' ? lightTheme : darkTheme,
    }),
    [theme]
  )

  return (
    <HoneycombThemeProvider
      family={isElectron() ? 'sea' : 'gold'}
      variant={variant}
      localTheme={localTheme}
    >
      {children}
    </HoneycombThemeProvider>
  )
}

DexThemeProvider.propTypes = {
  children: node.isRequired,
  theme: oneOf(['light', 'dark']).isRequired,
}
